import { config } from "../../config/config";
import { Observable } from 'rxjs';

export const LVGoalsPDFService = {
  saveLVGoalsPDF
}

function saveLVGoalsPDF(data) {
  let params = ''
  if (data.params) {
    params = data.params
  }
  return Observable.create(observer => {
    fetch(config.api_url + config.url.larningGoalsPDF + params, {
      method: 'POST',
      headers: {
        "Authorization": data.token
      }
    })
      .then(handleResponse)
      .then(result => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete()
        // return result.responceObject.records
      })
      .catch(error => {
        if (error.status === 401) {
          window.location.reload();
        }
      })
  })
}

function handleResponse(response) {
  // console.log('response....', response)
  return response.text().then(text => {
    // console.log('text....', text)
    const data = text && JSON.parse(text);
    // console.log('data...', data)
    if (!response.ok) {
      // console.log('ok1')
      if (response.status === 401) {
        // console.log('ok2')
        window.location.reload();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}